export const formatIsoDateBr = (iso?: string | null): string => {
  if (!iso?.trim()) return '';
  const parts = iso.trim().split('-');
  if (parts.length === 3) return parts.reverse().join('/');
  return iso.trim();
};

/** Data/hora em pt-BR, ex.: 30/08/2021 às 14:31 */
export const formatIsoDateTimeBr = (iso?: string | null): string => {
  if (!iso?.trim()) return '';
  const d = new Date(iso.trim());
  if (Number.isNaN(d.getTime())) return '';
  const dateStr = d.toLocaleDateString('pt-BR');
  const timeStr = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${dateStr} às ${timeStr}`;
};
